import { NavLink } from 'react-router-dom'
import { useResultsAvailable } from '@/hooks/useResultsAvailable'
import {
  mobileFooterPrimaryRoutes,
  mobileFooterSecondaryRoutes,
} from '@/app/routes'
import { brandIsotype } from '@/components/navigation/navigationAssets'

export function MobileBottomNavigation() {
  const resultsAvailable = useResultsAvailable()
  return (
    <nav className="mobile-bottom-nav" aria-label="Navegacion movil">
      <div className="mobile-bottom-nav__primary">
        <div className="mobile-bottom-nav__brand" aria-hidden="true">
          <img src={brandIsotype} alt="" />
        </div>

        {mobileFooterPrimaryRoutes.filter((route) => route.id !== 'resultados' || resultsAvailable).map((route) => (
          <NavLink
            key={route.id}
            to={route.path}
            className={({ isActive }) =>
              isActive ? 'mobile-bottom-nav__item is-active' : 'mobile-bottom-nav__item'
            }
          >
            <span>{route.label}</span>
          </NavLink>
        ))}
      </div>

      <div className="mobile-bottom-nav__secondary">
        {mobileFooterSecondaryRoutes.map((route) => (
          <NavLink
            key={route.id}
            to={route.path}
            className={({ isActive }) =>
              isActive
                ? 'mobile-bottom-nav__utility is-active'
                : 'mobile-bottom-nav__utility'
            }
          >
            <span>{route.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
